import { GridColDef } from '@mui/x-data-grid';
import {
    Box,
    TextField,
    Alert,
    InputAdornment,
    Typography,
} from '@mui/material';
//

import SearchIcon from '@mui/icons-material/Search';
import { useMemo, useState, useEffect } from 'react';
// Removed unused Choice query import
import React from 'react';

import { useManageCmsParams } from '../ManageCMS/useManageCmsParams';
import CommonDataGrid from '../../Stateless/CommonDataGrid';
import { useDebounce } from '../Utils/useDounce';
import { useReferalManagement } from '../../Query/ReferalManagementQuery';


const ReferalManagement = () => {
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const snackbarMessage = ''; // Replace with actual message
    const snackbarSeverity: 'success' | 'error' | 'info' | 'warning' = 'info';

    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearch = useDebounce(searchTerm, 400);
    const { params, dispatch } = useManageCmsParams();
    const isReady = Boolean(params && Object.keys(params).length > 0);
    const memoizedParams = useMemo(() => {
        return isReady ? params : {};
    }, [isReady, params]);
     const { data: referalData, isLoading } = useReferalManagement(memoizedParams);

     console.log(referalData)

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value)
    };

    useEffect(() => {
        dispatch({ type: 'SET_SEARCH', payload: debouncedSearch ? debouncedSearch : undefined });
    }, [debouncedSearch]);

    const handlePageChange = (newPage: number) => {
        dispatch({ type: 'SET_PAGE', payload: newPage + 1 });
    };

    const handlePageSizeChange = (newSize: number) => {
        dispatch({ type: 'SET_LIMIT', payload: newSize });
    };


    const columns: GridColDef[] = [
        {
            field: 'sno',
            headerName: 'S.No',
            flex: 1, // small number
        },
        {
            field: 'referrerUserName',
            headerName: 'Referrer',
            flex: 2, // moderately sized
        },
        {
            field: 'usedUserName',
            headerName: 'Referred User',
            flex: 2, // moderately sized
        },
        {
            field: 'referralCode',
            headerName: 'Referral Code',
            flex: 2,
        },
        {
            field: 'offerPercentage',
            headerName: 'Offer Percentage',
            flex: 2, // usually a long string
        },
        {
            field: 'walletAmount',
            headerName: 'Wallet Amount',
            flex: 1, // moderate length, like name
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
        },
    ];
    const rows = React.useMemo(() => {
        const items = referalData?.data ?? [];
        const page = Number(params.page ?? 1);
        const limit = Number(params.limit ?? 10);
        return items.map((item: any, index: number) => ({
            id: item.referralId,
            sno: index + 1 + (page - 1) * limit,
            referrerUserName: item.referrerUserName,
            usedUserName: item.usedUserName ?? '-',
            referralCode: item.referralCode,
            offerPercentage: item.offerPercentage,
            walletAmount: item.walletAmount,
            status: item.status,
        }));
    }, [referalData, params.page, params.limit]);

    const handleRowSelection = (selectionModel: any) => {
        setSelectedRows(selectionModel);
    };



    return (
        <>
            <Typography variant="h5" fontWeight="bold" mb={2}>
                Referal Management
            </Typography>
            <Box
                sx={{
                    p: 2,
                    border: '1px solid #e0e0e0',
                    marginTop: '20px',
                    color: '#666',
                }}
            >
                {snackbarOpen && (
                    <Box sx={{ mb: 2 }}>
                        <Alert
                            severity={snackbarSeverity}
                            onClose={() => setSnackbarOpen(false)}
                        >
                            {snackbarMessage}
                        </Alert>
                    </Box>
                )}

                <Box
                    sx={{
                        // p: 2,
                        mb: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 2, // Optional: adds spacing between wrapped items
                    }}
                >
                    {/* Search - Left */}
                    <Box
                        sx={{
                            width: 600,
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            background: '#fff',
                        }}
                    >
                        <TextField
                            fullWidth
                            placeholder="Search by email"
                            size="medium"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            sx={{
                                '.MuiOutlinedInput-root': {
                                    height: 40,
                                    width: 600,
                                    border: 'none', // remove inner border
                                },
                                '& fieldset': {
                                    border: 'none', // remove Material-UI default border
                                },
                                '& .MuiInputBase-input': {
                                    paddingTop: '10px', // adjust this value to move the placeholder lower
                                },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon
                                            sx={{ fontSize: 20, color: '#aaa', mt: '4px' }}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                    {/* Action Buttons + Add Button - Right */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            flexWrap: 'wrap',
                        }}
                    >
                    </Box>
                </Box>
                <CommonDataGrid
                    key={`datagrid-page-${params.page}-limit-${params.limit}`}
                    rows={rows || []}
                    columns={columns}
                    pageSize={params.limit}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                    checkboxSelection
                    loading={isLoading}
                    page={params.page - 1}
                    rowCount={referalData?.pagination?.totalItems}
                    components={{}}
                    onRowSelectionModelChange={handleRowSelection}
                    selectionModel={selectedRows}
                />
            </Box>
        </>
    );
};

export default ReferalManagement;
